import './HeaderText.css';

export type HeaderTextProps = {
  src: string;
  alt: string;
  className: string;
};

/** Shared absolute-positioned header image text. */
export function HeaderText({ src, alt, className }: HeaderTextProps) {
  return (
    <img className={className} src={src} alt={alt} draggable={false} />
  );
}
